import { useReportRepository, useAuditLogRepository } from '../repositories';

export function useReports() {
  const repo = useReportRepository();
  return repo.useList();
}

export function useGenerateReport() {
  const repo = useReportRepository();
  const { create, loading, error } = repo.useCreate();
  return {
    mutate: (input: any) => create(input),
    mutateAsync: (input: any) => create(input),
    isPending: loading,
    loading,
    error,
  };
}

export function useAuditLogs(variables?: {
  page?: number;
  perPage?: number;
  action?: string;
  userId?: string;
  startDate?: string;
  endDate?: string;
}) {
  const repo = useAuditLogRepository();
  return repo.useList(variables);
}
